/* eslint-disable no-restricted-syntax */

import type { ReadonlyURLSearchParams } from "next/navigation";

// Re-export all from shared-api
export {
	numToStr,
	bigintToStr,
	URLSearchParamsToStr,
	functionToStr,
	unknownToStr,
} from "@intents-explorer/shared-api/type-safe-stringify";

// Next.js specific function - kept here due to dependency on next/navigation
export function readonlyURLSearchParamsToStr(
	params: ReadonlyURLSearchParams,
): string {
	return params.toString();
}
